import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  button: {
    borderRadius: '16px',
    textTransform: 'capitalize',
    transition: 'background-color 0.15s linear',
  },
  circularProgress: {
    color: theme.palette.primary.contrastText,
  },
}));
